export default __webpack_public_path__ + "static/media/supabase.9838be89.svg";